import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'


const Footer = () => {
    return (
        <div className='bg-[#F8FBF8] dark:bg-black'>
            <footer className="text-green-600 body-font font-poppins text-xl">
                <div className="container px-5 py-12 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
                    <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
                        <a href="/" className="flex title-font font-medium items-center md:justify-start justify-center text-green-900">
                            <img className='h-16 w-16' src={logo} alt='logo-home' />
                            <span className="ml-3 text-2xl">Go Green</span>
                        </a>
                        <p className="mt-2 text-sm text-green-500"> Go green,<br /> and the earth will be clean</p>
                    </div>
                    <div className="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center justify-end">

                        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
                            <h2 className="title-font font-medium text-green-900 tracking-widest mb-3">Quick Links</h2>
                            <nav className="list-none mb-10 text-xl">
                                <li>
                                    <Link to="Landing" className="text-green-600 hover:text-green-800">Home</Link>
                                </li>
                                <li>
                                    <Link to="Shop" className="text-green-600 hover:text-green-800">Products</Link>
                                </li>
                                <li>
                                    <Link to="Shop" className="text-green-600 hover:text-green-800">Shops</Link>
                                </li>
                                <li>
                                    <Link to="about" className="text-green-600 hover:text-green-800">About Us</Link>
                                </li>
                            </nav>
                        </div>
                        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
                            <h2 className="title-font font-medium text-green-900 tracking-widest mb-3">Contact Us</h2>
                            <nav className="list-none mb-10 text-xl">
                                <li>
                                    <a href="https://www.youtube.com/watch?v=TXGbhniTBrU&t=2s&ab_channel=GlyphoricVibes" className="text-green-600 hover:text-green-800">Group 10</a>
                                </li>
                                <li>
                                    <a href="mailto:go.green.nursery@outlook.com" className="text-green-600 hover:text-green-800">go.green.nursery@outlook.com</a>
                                </li>
                                <li>
                                    <a href="http://mnnit.ac.in/" className="text-green-600 hover:text-green-800">XYZ , India</a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/search?gs_ssp=eJzj4tTP1TcwMijOTjZg9OIsKEqsTEwvSswCAEilBvc&q=prayagraj&rlz=1C1ONGR_enIN1028IN1028&oq=prya&aqs=chrome.1.69i57j46i10i433i512j69i59j46i10i175i199i512l2j0i10i512l4.16730j0j7&sourceid=chrome&ie=UTF-8" className="text-green-600 hover:text-green-800">Prayagraj</a>
                                </li>
                            </nav>
                        </div>

                    </div>
                </div>
                <div className="bg-gray-100 dark:bg-black">
                    <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
                        <p className="text-green-500 text-sm text-center sm:text-left">© 2022 Go Green —
                            <a href="/" className="text-green-600 ml-1" >@gogreen</a>
                        </p>
                        <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
                            <a href="https://www.facebook.com/profile.php?id=100087744285376" className="text-green-500">
                                <svg fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                                </svg>
                            </a>
                            <a href="https://twitter.com/GoGreenMNNIT" className="ml-3 text-green-500">
                                <svg fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/go_green_mnnit/" className="ml-3 text-green-500">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                                    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                                </svg>
                            </a>
                            <a href="http://www.linkedin.com/in/go-green-mnnit" className="ml-3 text-green-500">
                                <svg fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0" className="w-5 h-5" viewBox="0 0 24 24">
                                    <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
                                    <circle cx="4" cy="4" r="2" stroke="none"></circle>
                                </svg>
                            </a>
                        </span>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer